var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{staticClass:"elevation-1",attrs:{"three-line":""}},[_vm._t("row",null,null,{ items: _vm.computedItems }),_c('v-btn',{attrs:{"block":"","text":"","color":"primary"},on:{"click":_vm.loadMore}},[_vm._v(" load more ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }